/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { IoIosArrowForward } from "react-icons/io";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-bottom: 1px solid lightgray;
`;

const StyleTypeContainer = styled.div`
  font-weight: bold;
  font-size: 1em;
`;

const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px 15px;
`;

const StyledInfoTitle = styled.span`
  color: black;
  font-size: 0.9em;
  margin-top: 10px;
  margin-bottom: 5px;
  text-align: start;
`;

const StyledDescription = styled.span`
  color: gray;
  font-size: 0.9em;
  margin-top: 5px;
`;

const StyledValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 15px;
  font-size: 1em;
`;

class PaymentHistoryItem extends Component {
  render() {
    const { type, title, date, value } = this.props;

    return (
      <StyledContainer>
        <StyledInfoContainer>
          <StyleTypeContainer>{type}</StyleTypeContainer>
          <StyledInfoTitle>{title}</StyledInfoTitle>
          <StyledDescription>{date}</StyledDescription>
        </StyledInfoContainer>
        <StyledValueContainer>
          <span>{value}</span>
        </StyledValueContainer>
      </StyledContainer>
    );
  }
}

PaymentHistoryItem.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

export default PaymentHistoryItem;



// WEBPACK FOOTER //
// ./src/components/PaymentHistoryItem/index.js